import { render } from "./VtoPageError.vue?vue&type=template&id=09376364"
import script from "./VtoPageError.vue?vue&type=script&lang=js"
export * from "./VtoPageError.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__